const normalizeLabel = (label) => String(label || '').trim().toLowerCase()

export const getActiveNumericFields = (fields = []) => (
  fields.filter((field) => field && !field.archived_at && (!field.field_type || field.field_type === 'number'))
)

export const getOptionByValue = (options = [], value) => {
  if (value === null || value === undefined) return undefined

  const normalizedValue = String(value).toLowerCase()
  return options.find(
    (option) => String(option?.value).toLowerCase() === normalizedValue
  )
}

const resolveMetricField = (metric, fields) => {
  const exactMatch = fields.find((field) => field.id === metric.field_id)
  if (exactMatch) return exactMatch

  const normalizedMetricLabel = normalizeLabel(metric.label)
  if (!normalizedMetricLabel) return undefined

  const labelMatches = fields.filter(
    (field) => normalizeLabel(field.label) === normalizedMetricLabel
  )

  // A deleted/recreated field can be repaired by label only when that label
  // identifies one active field. Ambiguous matches must be selected manually.
  return labelMatches.length === 1 ? labelMatches[0] : undefined
}

export const getMetricsFieldsFromData = (
  metrics = [],
  operations = [],
  dynamicFields = []
) => {
  const activeFields = getActiveNumericFields(dynamicFields)
  const calcLabels = Object.fromEntries(
    operations.map((operation) => [operation.value, operation.text])
  )

  return metrics.reduce((formFields, metric) => {
    const { ref, calc, ranges, color_hexes: colorHexes } = metric
    const field = resolveMetricField(metric, activeFields)

    return {
      ...formFields,
      ...(field && { [`${ref}Field`]: field.id }),
      ...(field && { [`${ref}FieldLabel`]: field.label }),
      ...(calc && { [`${ref}Calc`]: calc }),
      ...(calc && { [`${ref}CalcLabel`]: calcLabels[calc] || '' }),
      [`${ref}Slider`]: ranges || [],
      ...(ref === 'color' && colorHexes && { colorHexes })
    }
  }, {})
}
